import React, { useEffect } from "react";
import { motion } from "framer-motion";

function MySubjects() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const student = {
    name: "Abdul Waliul Khandakar",
    class: "I",
    section: "A",
  };

  const subjects = [
    { name: "English", teacher: "Mrs. Rani Sharma" },
    { name: "Mathematics", teacher: "Mr. Rajeev Das" },
    { name: "EVS", teacher: "Ms. Priyanka Hazarika" },
    { name: "Assamese", teacher: "Mr. Anupam Kalita" },
    { name: "Computer Science", teacher: "Ms. Pooja Thakur" },
    { name: "Moral Science", teacher: "Mr. Abdul Haque" },
    { name: "Drawing", teacher: "Ms. Deepa Devi" },
  ];

  return (
    <motion.div
      className="min-h-screen bg-gray-50 p-4 pb-32"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      {/* Back Button */}
      <button
        onClick={() => window.history.back()}
        className="mb-4 text-pragyaBlue hover:underline font-medium ml-2 text-white"
      >
        ←
      </button>

      {/* Header Section */}
      <div className="bg-white rounded-xl shadow-lg overflow-hidden -mt-12">
        <div className="flex flex-col items-center bg-pragyaBlue text-white p-2">
          <h2 className="text-md font-semibold text-center">{student.name}</h2>
        </div>

        {/* Subject List Section */}
        {/* <div className="flex flex-col items-center bg-pragyaBlue text-white p-2">
          <h2 className="text-md font-semibold text-center">My Subjects</h2>
        </div> */}
        <div className="p-6 text-sm sm:text-base text-gray-700">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <h2 className="text-md font-semibold text-center uppercase">My Subjects</h2>

            {subjects.map((subject, idx) => (
              <div
                key={idx}
                className="border p-4 rounded-lg bg-white shadow-sm"
              >
                <p>
                  <strong>Subject:</strong> {subject.name}
                </p>
                <p>
                  <strong>Class Teacher:</strong> {subject.teacher}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default MySubjects;
